"use client";
// @ts-strict-ignore
import styled from "styled-components";
import { web } from "@hubble/tokens";

export const TokenCardSilderWrapper = styled.div`
  margin: 3rem 0;
  width: calc(100% + 16px);
  positon: relative;
  ${({ theme: { media } }) => media.mobileLandscape`
  width: 100%;
`};
`;

export const TokenCardSilderArrows = styled.div`
  justify-content: center;
  align-items: center;
  gap: 22px;

  & > button {
    cursor: pointer;
    padding: 10px;
  }
`;
export const SliderWrapper = styled.div`
  display: flex;
  overflow: auto;
  overscroll-behavior: contain;
  gap: ${web.spacing[16]};
  &::-webkit-scrollbar {
    display: none;
  }
  .slick-slide {
    margin: 0 0.5rem;
  }
`;
export const TokenBox = styled.div`
  display: flex;
  justify-content: space-between;
`;
